// extracted by mini-css-extract-plugin
export default {"dropzone":"VemlM","root":"zpR6w","aspectSwitcher":"ZgtKd","placeholder":"aWT_E","error":"_nlT5","label":"zXjAg","button":"djVkb","description":"_ik_l"};